import { createApolloClient } from "./ApolloClientFactory";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../config/auth/AuthConfig";

export const msalInstance = new PublicClientApplication(msalConfig);
export const apolloClient = createApolloClient(msalInstance);
